export const BaseUrl = "https://backendshineinlavender.quindl.com";

// export const BaseUrl = "https://ecom-api-quindl.onrender.com";

// export const BaseUrl = "http://localhost:7777";

